import ScreeningAssessment, {
  ScreeningAssessmentProps,
} from "../ScreeningAssessment";
import { HOME_HEALTH_SCREENER_TYPES } from "../assessment-constant";

export type AnnualWellnessAssessmentProps = Omit<
  ScreeningAssessmentProps,
  "type"
>;

const AnnualWellnessAssessment = (props: AnnualWellnessAssessmentProps) => (
  <ScreeningAssessment
    {...props}
    type={HOME_HEALTH_SCREENER_TYPES.annualWellness}
  />
);

export default AnnualWellnessAssessment;
